import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function Solucion() {
  return <section className="bg-gradient-to-br from-mc-gray to-mc-dark py-[72px] px-5" data-id="element-164">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-165">
        <FadeIn data-id="element-166">
          <SectionHeading centered data-id="element-167">
            Mecánico Check te da el control{' '}
            <span className="text-mc-yellow" data-id="element-168">antes de pagar</span>
          </SectionHeading>
          <p className="text-mc-text text-[1.05rem] leading-[1.7] max-w-[640px] mx-auto mt-5" data-id="element-169">
            Un sistema práctico para saber qué mirar, qué preguntar y qué
            mantenimientos básicos podés hacer vos mismo.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-170">
          <div className="mt-8 mx-auto max-w-[680px] bg-mc-gray2 border-2 border-mc-yellow rounded-lg p-6 md:p-7 text-[1.15rem] font-bold font-display text-center" data-id="element-171">
            "No comprás un ebook. Comprás{' '}
            <span className="text-mc-yellow" data-id="element-172">
              tranquilidad cada vez que vas al taller
            </span>
            ."
          </div>
        </FadeIn>
      </div>
    </section>;
}